import * as types from '../actions/types'

const initialState = {
  errorsToBeDisplayed: {},
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_ERROR_TO_DISPLAY:
      return {
        errorsToBeDisplayed: {
          ...state.errorsToBeDisplayed,
          [payload.errorKey]: payload.errorData,
        },
      }
    default:
      return state
  }
}
